import React from 'react';
import Submenu from './Submenu';

import config from '../../../config';

class SupportMenu extends Submenu {

  constructor(props) {
    super(props);
    this.links = config.links;
  }

  render() {
    const navClasses = super.getMenuClasses('supportMenu');
    return (
      <ul id="accountMenu" className={navClasses}>
        <li className="header">Support</li>
        <li className="default"><a href={this.links.account.contact}>Contact Us</a></li>
      </ul>
    );
  }
}

export default SupportMenu;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/menus/SupportMenu.js